import styled from "styled-components";

const SectionTitle = styled.h2``;

export default SectionTitle;
